import { render, staticRenderFns } from "./OAuthLogin.vue?vue&type=template&id=4855e8ae&scoped=true&"
import script from "./OAuthLogin.vue?vue&type=script&lang=ts&"
export * from "./OAuthLogin.vue?vue&type=script&lang=ts&"
import style0 from "./OAuthLogin.vue?vue&type=style&index=0&id=4855e8ae&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4855e8ae",
  null
  
)

export default component.exports